<template>
  <v-container fluid  class="d-flex flex-column ">
    <v-row justify="center">
      <v-col xs="12" sm="12" md="12" lg="10" class="pt-8">
      <div class="mb-15 pb-5 text-h3 font-weight-light">{{ $t('menus.clients') }}</div>
      <v-card  elevation="12" rounded="lg">
        <v-data-table
          class="pa-2"
          :headers="clientHeaders"
          :items="formattedClients"
          :items-per-page="10"
          :footer-props="{
            itemsPerPageOptions: [10,20,50],
            showFirstLastPage: true
          }"
        >
        <template v-slot:item.transactedVolume="{item}">
            <span
              :style="{
                color: !isNaN(item.rawTransactedVolume)
                  ? (item.rawTransactedVolume > 10000 ? 'green' : 'red')
                  : ''
              }"
            > 
                 {{ isNaN(item.rawTransactedVolume) ? '-': item.transactedVolume }} 
            </span>
        </template>
          <template v-slot:item.status="{ item }">
            <div>
              <v-chip
                v-if="item.status === 'Active' || item.status === 'Paused'"
                small
                :color="item.status === 'Active' ? 'green' : 'red'"
              >
                {{ item.status }}
              </v-chip>
            </div>
          </template>
        </v-data-table>
      </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/*mocked
[
  {
    "name": "Eletrobras",
    "cnpj": "00001180000126",
    "broker": "31026ddd89f8e9cd1eb8c23b4a699c51b5c28087",
    "banklist": [
      {
        "name": "Banco ABC Brasil",
        "id": "00000000000001",
        "timeDue": 45
      },
      {
        "name": "Banco ASA",
        "id": "00000000000002",
        "timeDue": 90
      },
      {
        "name": "Banco BS2",
        "id": "00000000000003",
        "timeDue": 75
      }
    ],
    "blocked": 0,
    "id": "22057ae8e3ac3b44a363b7f9580e4e53485ecd3c",
    "timecreate": 1758214160.8703291,
    "lastTrade": "2025-09-18T16:57:18.646Z",
    "transactedVolume": 21183,
    "revenue": 20,
    "timelast": 1758214638.689927,
    "user": {
      "name": "marcelo",
      "email": "marcnobremorais@gmail.com",
      "broker": null,
      "company": "22057ae8e3ac3b44a363b7f9580e4e53485ecd3c",
      "role": "pro",
      "id": "daaf334781848939525bc2ca1f941139a6551e3a",
      "timecreate": 1758214160.886717
    }
  },
  {
    "name": "quartix.io Agent",
    "cnpj": "00000000000001",
    "broker": "31026ddd89f8e9cd1eb8c23b4a699c51b5c28087",
    "banklist": [
      {
        "name": "Banco Fibra",
        "id": "00000000000007",
        "timeDue": 50
      },
      {
        "name": "Banco ABC Brasil",
        "id": "00000000000001",
        "timeDue": 45
      }
    ],
    "blocked": 0,
    "id": "f561da7a9cfcd0e0449d79ed1ec0058b92d26611",
    "timecreate": 1758315813.3149786,
    "timelast": 1758315832.3576977,
    "user": {
      "name": "quartix.io pricer Agent",
      "email": "pricer@quartix.io",
      "broker": null,
      "company": "f561da7a9cfcd0e0449d79ed1ec0058b92d26611",
      "role": "pricer",
      "id": "f003d61201bb480442b5b4029a67313a1d9024e3",
      "timecreate": 1758315819.8202975
    }
  }
]*/
import { useExecutionStore } from "../store/index";
import { mapActions } from "pinia";
export default {
  data() {
    return {
      brokerId: null,
      clientList: [],
      clientHeaders: [
        { text: "Client Name", value: "name"},
        { text: "Client CNPJ", value: "cnpj" },
        { text: "Client ID", value: "id" },
        { text: "Last Trade", value: "lastTrade" },
        { text: "Transacted Volume", value: "transactedVolume" },
        { text: "Status", value: "status" },
      ],
    };
  },
  mounted() {
    this.getCompany();
  },
  methods: {
    ...mapActions(useExecutionStore, ["getCompaniesByBankId", "getCompanyStats"]),
    getCompany() {
      const bankId = localStorage.getItem("bankId");
      Promise.all([
        this.getCompaniesByBankId(bankId),
        this.getCompanyStats()
      ]).then(([companiesRes, statsRes]) => {
        const list = companiesRes.data || [];
        const statsMap = statsRes.data || {};
        // Merge stats onto each company by id.
        list.forEach(c => Object.assign(c, statsMap[c.id] || {}));
        this.clientList = [...list];
      });
    },
    formatCurrencyBRLCompactAbbr (val) {
      const formatted = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        notation: 'compact',
        maximumFractionDigits: 1
      }).format(val)

      return formatted
        .replace(/\s?mil/i, 'k')
        .replace(/\s?mi/i, 'M')
        .replace(/\s?bi/i, 'B')
    },
  },
  computed: {
    formattedClients() {
      return this.clientList.map((client) => {
        return {
          name: client.name,
          id: client.id,
          cnpj: client.cnpj,
          status:client.blocked === 0 ? "Active" : "Paused",
          lastTrade:client.lastTrade?  new Date(client.lastTrade).toLocaleDateString("en-GB"): "",
          transactedVolume: "-",
          rawTransactedVolume:"-"
        };
      });
    },
  },
};
//getCompaniesByBrokerId
</script>
